// frontend/src/utils/color.js

export function getSeverityFilled(sev) {
  const s = String(sev || '').toLowerCase();
  return s === 'high' ? 4 : s === 'medium' ? 3 : s === 'low' ? 2 : s === 'info' ? 1 : 0;
}

export function getSeverityText(s) {
  return s === 4 ? 'High' : s === 3 ? 'Medium' : s === 2 ? 'Low' : s === 1 ? 'Info' : 'Unknown';
}


export function getSeverityColor(s, isSafe) {
  if (isSafe) {
    return '#4caf50'; // Green for safe
  }
  return s === 4 ? '#C62828' : s === 3? '#FB8C00' : s === 2 ? '#FFCA28' : '#90caf9';
}

export default {
  getSeverityFilled,
  getSeverityColor,
  getSeverityText
};
